import * as Sentry from '@sentry/react'
import {BrowserTracing} from '@sentry/tracing'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './app'

const SENTRY_DSN =
	process.env.SENTRY_DSN ||
	'https://47dce5f903b8489aa0b6b4cca2d24de6@o60758.ingest.sentry.io/6270858'

Sentry.init({
	dsn: SENTRY_DSN,
	integrations: [new BrowserTracing()],
	environment: process.env.SENTRY_ENVIRONMENT
	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for performance monitoring.
	// We recommend adjusting this value in production
	// tracesSampleRate: 1.0
})

ReactDOM.render(<App />, document.getElementById('root'))
